var exports = {
  "QN": "x61f99309--63961d--modal-container",
  "M$": "x61f99309--63961d--header-content",
  "_R": "x61f99309--63961d--close-button",
  "Qs": "x61f99309--63961d--content",
  "DD": "x61f99309--63961d--title",
};

module.exports = exports;
